import React from "react";
import { Share2 } from "lucide-react";
import { toast } from "@/lib/toast";

// Shares the backend /api/share/* link (server-rendered OG preview) — never the raw SPA URL,
// which crawlers only ever see as the generic site card.
export function ShareLinkButton({ sharePath, title, testid, className = "", style }) {
  const onShare = async () => {
    const url = `${window.location.origin}/api/share/${sharePath}`;
    try {
      if (navigator.share) { await navigator.share({ title, url }); return; }
      await navigator.clipboard.writeText(url);
      toast.success("Share link copied — it shows a preview with a photo and title.");
    } catch { /* user cancelled share */ }
  };
  return (
    <button type="button" onClick={onShare} data-testid={testid} className={className} style={style}>
      <Share2 className="w-3.5 h-3.5" strokeWidth={2} /> Share
    </button>
  );
}
